import {Component, computed, effect, inject, input, OnInit} from '@angular/core';
import {IonCol, IonIcon, IonItem, IonLabel, IonList, IonRow} from "@ionic/angular/standalone";
import {LanguageService} from '../../../core/language.service';
import {addIcons} from 'ionicons';
import {extensionPuzzleOutline, peopleOutline, ribbonOutline, serverOutline} from 'ionicons/icons';
import {PageService} from '../../page.service';

@Component({
    selector: 'app-contact-details',
  template: `
    <h1>Get in touch with our team</h1>

    <h3>Location</h3>
    @defer (hydrate on viewport) {
      <ion-list lines="none"
                [dir]="languageService.dir()" [lang]="languageService.lang()">
        <ion-item>
          <ion-icon slot="start"
                    name="location-outline"></ion-icon>
          <ion-label>
            <h4><a href="https://g.co/kgs/ZaaP2Ma" target="_blank">{{ contactDetails()?.[languageService.lang()].address }}</a></h4>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start"
                    name="time-outline"></ion-icon>
          <ion-label>
            <h4>{{ contactDetails()?.[languageService.lang()].openingHours }}</h4>
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-icon slot="start"
                    name="call-outline"></ion-icon>
          <ion-label><h4><a href="tel:{{contactDetails()?.phoneNumber1}}">{{ contactDetails()?.phoneNumber1 }}</a></h4></ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start"
                    name="call-outline"></ion-icon>
          <ion-label><h4><a href="tel:{{contactDetails()?.phoneNumber2}}">{{ contactDetails()?.phoneNumber2 }}</a></h4></ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start"
                    name="mail-outline"></ion-icon>
          <ion-label>
            <h4><a href="mailto:{{contactDetails()?.emailAddress}}">{{ contactDetails()?.emailAddress }}</a></h4>
          </ion-label>
        </ion-item>
      </ion-list>
    }
  `,
  styles: `
    h1 {
      font-size: 2.75rem;
      font-weight: 500;
      margin-bottom: 1rem;
    }
    p {
      font-size: .9rem;
    }
    h3 {
      color: var(--ion-text-color);
      font-size: 1.25rem;
      font-weight: 500;
    }
    ion-item {
      --padding-start: 0;
      font-size: .75rem;
      --min-height: 32px;
    }
    ion-col {
      padding: 0;
    }
  `,
  imports: [
    IonItem,
    IonLabel,
    IonList,
    IonIcon,
  ]
})
export class ContactDetailsComponent {
  languageService: LanguageService = inject(LanguageService);
  content: any;
  constructor() {
    addIcons( { ribbonOutline, extensionPuzzleOutline, serverOutline, peopleOutline });
  }
  pageService: PageService = inject(PageService);
  contactDetails = computed(() => this.pageService.pageContentResource.value()?.content);
  isContentLoading = this.pageService.pageContentResource.isLoading;

}
